// // pages/CurrentAffairsDetailPage.jsx
// import React, { useEffect, useState, useRef } from 'react';
// import { Link, useParams } from 'react-router-dom';
// import { motion } from 'framer-motion';

// const CurrentAffairsDetailPage = () => {
//   const { id } = useParams();
//   const [article, setArticle] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [activeSection, setActiveSection] = useState(null);
//   const [showScrollToTop, setShowScrollToTop] = useState(false);

//   const sectionRefs = useRef({});

//   useEffect(() => {
//     window.scrollTo(0, 0);

//     // In a real app, you would fetch the current affairs article by ID from an API
//     // For this example, we'll simulate fetching with sample data
//     setTimeout(() => {
//       setArticle(sampleArticle);
//       setLoading(false);
//     }, 500);

//     const handleScroll = () => {
//       // Show scroll to top button when user scrolls down
//       setShowScrollToTop(window.scrollY > 300);

//       // Update active section based on scroll position
//       if (sectionRefs.current) {
//         const sections = Object.keys(sectionRefs.current);
//         for (const section of sections) {
//           const element = sectionRefs.current[section];
//           if (element) {
//             const rect = element.getBoundingClientRect();
//             if (rect.top <= 100 && rect.bottom >= 100) {
//               setActiveSection(section);
//               break;
//             }
//           }
//         }
//       }
//     };

//     window.addEventListener('scroll', handleScroll);

//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, [id]);

//   const scrollToSection = (sectionId) => {
//     const element = sectionRefs.current[sectionId];
//     if (element) {
//       const offset = 80; // Account for fixed header
//       const elementPosition = element.getBoundingClientRect().top;
//       const offsetPosition = elementPosition + window.pageYOffset - offset;

//       window.scrollTo({
//         top: offsetPosition,
//         behavior: 'smooth'
//       });
//     }
//   };

//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth'
//     });
//   };

//   // Example current affairs article with multiple sections
//   const sampleArticle = {
//     id: 1,
//     title: "Chandrayaan-3 Mission: India's Historic Lunar South Pole Landing",
//     date: "September 15, 2023",
//     category: "Science & Technology",
//     relevance: ["NPSC GS Paper III", "Science & Technology", "National Achievements"],
//     author: "Dr. Imtisunep Ao",
//     authorPosition: "Science & Tech Expert",
//     image: "/images/current-affairs/chandrayaan-3.jpg",
//     readTime: "12 min read",
//     summary: "India made history by successfully landing the Chandrayaan-3 mission on the lunar south pole, becoming the first country to achieve this feat. This article explores the mission's objectives, achievements, and significance in the global space race.",
//     sections: [
//       {
//         id: "overview",
//         title: "Mission Overview",
//         content: `
//           <p>The Chandrayaan-3 mission, launched by the Indian Space Research Organisation (ISRO) on July 14, 2023, successfully landed on the lunar south pole on August 23, 2023, at 18:04 IST. The mission consists of a lander named 'Vikram' and a rover called 'Pragyan', designed to conduct in-situ scientific experiments on the lunar surface.</p>

//           <p>Following the partial success of Chandrayaan-2, where the orbiter continues to function but the lander crashed, Chandrayaan-3 was designed with a more robust landing system with improved fault tolerance. The mission's primary objective was to demonstrate India's capability to perform a soft landing on the lunar surface and operate a rover to conduct scientific experiments.</p>

//           <p>Chandrayaan-3 made history by touching down near the lunar south pole, an area of significant interest due to the potential presence of water ice in permanently shadowed regions. India became the first country to land a spacecraft in this region and the fourth country overall to achieve a soft landing on the Moon after the United States, Russia, and China.</p>
//         `
//       },
//       {
//         id: "key-objectives",
//         title: "Key Objectives and Scientific Goals",
//         content: `
//           <p>The Chandrayaan-3 mission was designed with several key scientific and technological objectives:</p>

//           <ul>
//             <li>Demonstrate safe and soft landing on the lunar surface</li>
//             <li>Demonstrate rover operations on the moon</li>
//             <li>Conduct in-situ scientific experiments to study the lunar surface composition</li>
//             <li>Analyze the lunar atmosphere</li>
//             <li>Investigate the presence of water molecules on the lunar surface</li>
//             <li>Study lunar seismic activity</li>
//             <li>Measure thermal properties of the lunar regolith</li>
//           </ul>

//           <p>The scientific payloads aboard the lander and rover were carefully selected to achieve these objectives. The lander carried instruments such as the Chandra's Surface Thermophysical Experiment (ChaSTE) to measure thermal conductivity and temperature, the Instrument for Lunar Seismic Activity (ILSA) to measure seismicity, and the Langmuir Probe (LP) to measure plasma density and its variations.</p>

//           <p>The Pragyan rover was equipped with the Alpha Particle X-ray Spectrometer (APXS) and Laser Induced Breakdown Spectroscope (LIBS) to determine the elemental composition of lunar soil and rocks near the landing site.</p>
//         `
//       },
//       {
//         id: "technology",
//         title: "Technological Advancements",
//         content: `
//           <p>Chandrayaan-3 incorporated several technological improvements over its predecessor to ensure mission success:</p>

//           <h3>Enhanced Propulsion System</h3>
//           <p>The mission featured an upgraded propulsion system with additional fuel capacity and improved throttleable engines that provided more precise control during the critical landing phase.</p>

//           <h3>Robust Landing Legs</h3>
//           <p>The lander was equipped with stronger landing legs designed to withstand higher landing velocities and rougher terrain, increasing the margin of error during touchdown.</p>

//           <h3>Advanced Navigation Systems</h3>
//           <p>Chandrayaan-3 utilized an improved suite of sensors including laser doppler velocimeters, altimeters, and cameras that provided more accurate real-time data during the descent. The lander also incorporated hazard detection and avoidance algorithms to identify and navigate around potential landing hazards.</p>

//           <h3>Communication Improvements</h3>
//           <p>Enhanced communication systems ensured robust data transfer between the lander, rover, orbiter (from Chandrayaan-2), and ground stations on Earth, allowing for better telemetry and command capabilities.</p>

//           <h3>Autonomous Operation</h3>
//           <p>Given the communication delay between Earth and the Moon, Chandrayaan-3 was designed with advanced autonomous capabilities, allowing the spacecraft to make critical decisions during the landing phase without real-time input from ground control.</p>
//         `
//       },
//       {
//         id: "achievement",
//         title: "Historic Achievement and Global Implications",
//         content: `
//           <p>The successful landing of Chandrayaan-3 marked several significant milestones:</p>

//           <h3>First South Pole Landing</h3>
//           <p>India became the first nation to land a spacecraft near the lunar south pole, a region of particular interest to the scientific community due to its unique characteristics and potential water ice deposits in permanently shadowed craters.</p>

//           <h3>Cost-Effective Space Exploration</h3>
//           <p>With a budget of approximately ₹615 crore (US$75 million), Chandrayaan-3 demonstrated India's ability to conduct complex space missions at a fraction of the cost compared to similar missions by other space agencies. This achievement reinforces India's position as a leader in cost-effective space exploration.</p>

//           <h3>Technology Demonstration</h3>
//           <p>The successful mission demonstrated India's growing technological capabilities in space exploration, particularly in developing reliable landing systems for extraterrestrial bodies.</p>

//           <h3>Scientific Value</h3>
//           <p>By landing near the lunar south pole, Chandrayaan-3 is positioned to collect valuable data about a relatively unexplored region of the Moon. The scientific findings could contribute significantly to our understanding of lunar geology, the presence of water ice, and the Moon's evolution.</p>

//           <p>The achievement holds particular significance as multiple countries and space agencies, including NASA's Artemis program, are focusing on the lunar south pole for future missions, considering it a potential site for establishing a permanent human presence on the Moon.</p>
//         `
//       },
//       {
//         id: "findings",
//         title: "Initial Findings and Operations",
//         content: `
//           <p>Following the successful landing, both the Vikram lander and Pragyan rover began their planned operations:</p>

//           <h3>Surface Explorations</h3>
//           <p>The Pragyan rover successfully deployed from the lander and began traversing the lunar surface. It traveled approximately 100 meters, conducting various scientific experiments along the way. The rover's mobility system performed as expected on the challenging lunar terrain.</p>

//           <h3>First Discoveries</h3>
//           <p>Initial data from the mission revealed several interesting findings:</p>

//           <ul>
//             <li>The ChaSTE experiment measured temperature variations at different depths below the lunar surface, providing insights into the thermal conductivity of lunar soil.</li>
//             <li>The LIBS instrument detected the presence of sulfur, which was unexpected and significant as it usually requires volatile-rich conditions to be present in such quantities.</li>
//             <li>Measurements also confirmed the presence of aluminum, calcium, iron, chromium, titanium, manganese, silicon, and oxygen, consistent with expectations for lunar highland soils.</li>
//           </ul>

//           <p>Perhaps most significantly, preliminary data suggested the possible presence of water molecules or hydroxyl (OH) groups in the lunar regolith, though further analysis was needed to confirm these findings.</p>

//           <h3>Extended Mission</h3>
//           <p>While initially planned for a mission duration of one lunar day (approximately 14 Earth days), both the lander and rover were put into sleep mode before the lunar night to conserve energy, with the possibility of reawakening when sunlight returned to power their solar panels.</p>
//         `
//       },
//       {
//         id: "future-implications",
//         title: "Future Implications for India's Space Program",
//         content: `
//           <p>The success of Chandrayaan-3 has significant implications for India's future space endeavors:</p>

//           <h3>Lunar Exploration Roadmap</h3>
//           <p>Building on this achievement, ISRO has outlined plans for additional lunar missions, including a potential sample return mission that would bring lunar material back to Earth for detailed analysis.</p>

//           <h3>International Collaborations</h3>
//           <p>The mission's success has opened doors for enhanced collaboration with other space agencies. ISRO is now in discussions with NASA, ESA, and other organizations about potential joint missions to the Moon and beyond.</p>

//           <h3>Human Spaceflight</h3>
//           <p>The technologies developed for Chandrayaan-3, particularly those related to soft landing and autonomous operations, will contribute to India's human spaceflight program, Gaganyaan, which aims to send Indian astronauts to low Earth orbit.</p>

//           <h3>Deep Space Missions</h3>
//           <p>The expertise gained from Chandrayaan-3 will also benefit India's planned missions to other planetary bodies, including the Shukrayaan mission to Venus and potential future missions to Mars.</p>

//           <p>Beyond these specific programs, the mission has inspired a new generation of Indian scientists and engineers, potentially accelerating the development of India's space technology sector and strengthening the country's position as a major player in global space exploration.</p>
//         `
//       },
//       {
//         id: "examination-perspective",
//         title: "NPSC Examination Perspective",
//         content: `
//           <p>From the perspective of NPSC examination preparation, the Chandrayaan-3 mission offers several important dimensions for study:</p>

//           <h3>Science & Technology</h3>
//           <p>The mission demonstrates India's technological capabilities and contributes to basic knowledge about the Moon's geology and composition. Candidates should understand the scientific objectives, instruments used, and preliminary findings.</p>

//           <h3>International Relations</h3>
//           <p>Chandrayaan-3's success positions India prominently in the global space arena. Candidates should analyze how this achievement impacts India's diplomatic standing and potential for international scientific collaboration.</p>

//           <h3>Economic Aspects</h3>
//           <p>The cost-effectiveness of India's space missions, including Chandrayaan-3, represents a unique approach to space exploration. Candidates should examine the economic model of ISRO and how it balances ambitious scientific goals with budget constraints.</p>

//           <h3>National Pride and Soft Power</h3>
//           <p>The mission has boosted national morale and enhanced India's soft power globally. Candidates should consider how scientific achievements contribute to nation-building and international prestige.</p>

//           <h3>Possible Questions</h3>
//           <p>For the NPSC examination, candidates might encounter questions such as:</p>

//           <ul>
//             <li>Discuss the scientific and strategic significance of India's Chandrayaan-3 mission to the lunar south pole. (250 words)</li>
//             <li>How does India's space program balance scientific objectives with national development priorities? Illustrate with the example of recent lunar missions. (150 words)</li>
//             <li>Examine the technological challenges overcome by ISRO in achieving a successful soft landing on the Moon's south pole region. (150 words)</li>
//             <li>Analyze the impact of space achievements like Chandrayaan-3 on India's standing in the international community. (100 words)</li>
//           </ul>
//         `
//       }
//     ],
//     faqs: [
//       {
//         question: "Why is landing on the lunar south pole significant?",
//         answer: "The lunar south pole is significant because it contains permanently shadowed regions where water ice may be present due to the absence of direct sunlight. This ice could be a valuable resource for future lunar missions and potential human settlements. Additionally, the region has unique geological features that could provide insights into the Moon's history and formation."
//       },
//       {
//         question: "How does Chandrayaan-3 differ from Chandrayaan-2?",
//         answer: "Chandrayaan-3 was essentially a follow-up mission focused on successfully demonstrating the landing capabilities that weren't achieved in Chandrayaan-2. The main difference is that Chandrayaan-3 included only a lander and rover, while Chandrayaan-2 also had an orbiter component. Chandrayaan-3 featured enhanced landing systems with improved fault tolerance, stronger landing legs, and additional sensors for more precise navigation during descent."
//       },
//       {
//         question: "What scientific instruments were aboard Chandrayaan-3?",
//         answer: "Chandrayaan-3's lander carried instruments including the Chandra's Surface Thermophysical Experiment (ChaSTE) to measure thermal properties, the Instrument for Lunar Seismic Activity (ILSA) to detect moonquakes, and a Langmuir Probe to study plasma near the lunar surface. The rover was equipped with an Alpha Particle X-ray Spectrometer (APXS) and a Laser Induced Breakdown Spectroscope (LIBS) to determine the elemental composition of lunar soil and rocks."
//       },
//       {
//         question: "How does India's achievement compare with other countries' lunar missions?",
//         answer: "India became the fourth country to successfully land on the Moon after the United States, the Soviet Union (now Russia), and China. However, India is the first country to successfully land near the lunar south pole, a technically challenging region of great scientific interest. India also accomplished this mission at a significantly lower cost compared to similar missions by other space agencies, demonstrating its efficient use of resources in space exploration."
//       }
//     ],
//     related: [
//       {
//         id: 2,
//         title: "Aditya L1: India's First Solar Mission",
//         category: "Science & Technology",
//         date: "September 2, 2023",
//         image: "/images/current-affairs/aditya-l1.jpg"
//       },
//       {
//         id: 3,
//         title: "G20 Summit 2023: India's Leadership on the Global Stage",
//         category: "International Relations",
//         date: "September 10, 2023",
//         image: "/images/current-affairs/g20-summit.jpg"
//       },
//       {
//         id: 4,
//         title: "National Education Policy 2020: Three Years of Implementation",
//         category: "Governance",
//         date: "August 29, 2023",
//         image: "/images/current-affairs/nep-2020.jpg"
//       }
//     ],
//     keywords: ["Chandrayaan-3", "ISRO", "Lunar South Pole", "Space Exploration", "Pragyan Rover", "Vikram Lander", "Indian Space Program"]
//   };

//   if (loading) {
//     return (
//       <div className="pt-20 flex justify-center items-center min-h-screen bg-gray-50">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-700 mx-auto"></div>
//           <p className="mt-3 text-gray-600">Loading article...</p>
//         </div>
//       </div>
//     );
//   }

//   if (!article) {
//     return (
//       <div className="pt-20 flex justify-center items-center min-h-screen bg-gray-50">
//         <div className="text-center max-w-lg mx-auto px-4">
//           <svg className="h-16 w-16 text-gray-400 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//           </svg>
//           <h2 className="mt-4 text-xl font-bold text-gray-700">Article Not Found</h2>
//           <p className="mt-2 text-gray-500">The article you're looking for doesn't exist or has been removed.</p>
//           <Link to="/current-affairs" className="mt-6 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-gray-600 hover:bg-gray-700">
//             Back to Current Affairs
//           </Link>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="pt-20 bg-gray-50">
//       {/* Hero Section */}
//       <div className="relative bg-gray-900 text-white">
//         <div className="absolute inset-0">
//           <div className="absolute inset-0 bg-gradient-to-r from-gray-900 to-blue-900 opacity-90"></div>
//           {article.image && (
//             <img
//               src={article.image}
//               alt={article.title}
//               className="absolute inset-0 w-full h-full object-cover mix-blend-overlay opacity-40"
//             />
//           )}
//         </div>
//         <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
//           <div className="max-w-3xl">
//             <div className="mb-4 flex items-center space-x-2">
//               <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-gray-100 text-gray-800">
//                 {article.category}
//               </span>
//               <span className="text-gray-200 text-sm">{article.date}</span>
//             </div>

//             <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight mb-6">
//               {article.title}
//             </h1>

//             <p className="text-xl text-gray-100 mb-8">
//               {article.summary}
//             </p>

//             <div className="flex flex-wrap items-center gap-3 md:gap-6 text-sm text-gray-200">
//               <div className="flex items-center">
//                 <div className="flex-shrink-0 mr-2">
//                   <div className="h-10 w-10 rounded-full bg-gray-700 flex items-center justify-center text-xl font-bold">
//                     {article.author.charAt(0)}
//                   </div>
//                 </div>
//                 <div>
//                   <div className="font-medium text-white">{article.author}</div>
//                   <div className="text-xs">{article.authorPosition}</div>
//                 </div>
//               </div>

//               <div className="flex items-center">
//                 <svg className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//                 <span>{article.readTime}</span>
//               </div>

//               <div className="flex items-center">
//                 <svg className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
//                 </svg>
//                 <span>Save for later</span>
//               </div>

//               <div className="flex items-center">
//                 <svg className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
//                 </svg>
//                 <span>Share</span>
//               </div>
//             </div>

//             <div className="mt-8 flex flex-wrap gap-2">
//               {article.relevance.map((item, index) => (
//                 <span
//                   key={index}
//                   className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-gray-800 text-gray-100"
//                 >
//                   {item}
//                 </span>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Content with Sidebar */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
//         <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
//           {/* Table of Contents Sidebar - Fixed on Desktop */}
//           <div className="lg:col-span-3 order-2 lg:order-1">
//             <div className="lg:sticky lg:top-24">
//               <div className="bg-white rounded-lg shadow-md p-6">
//                 <h2 className="text-lg font-bold text-gray-900 mb-4">In This Article</h2>
//                 <nav className="space-y-2">
//                   {article.sections.map((section) => (
//                     <button
//                       key={section.id}
//                       onClick={() => scrollToSection(section.id)}
//                       className={`block w-full text-left px-3 py-2 rounded text-sm ${
//                         activeSection === section.id
//                           ? 'bg-gray-50 text-gray-700 font-medium'
//                           : 'text-gray-600 hover:bg-gray-50'
//                       }`}
//                     >
//                       {section.title}
//                     </button>
//                   ))}
//                 </nav>

//                 <div className="mt-6 border-t border-gray-200 pt-4">
//                   <a
//                     href="#"
//                     onClick={(e) => {
//                       e.preventDefault();
//                       window.print();
//                     }}
//                     className="flex items-center text-gray-600 hover:text-gray-600 text-sm"
//                   >
//                     <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
//                     </svg>
//                     Print Article
//                   </a>

//                   <a
//                     href="#"
//                     onClick={(e) => {
//                       e.preventDefault();
//                       // PDF download logic would go here
//                       alert('Downloading PDF...');
//                     }}
//                     className="flex items-center text-gray-600 hover:text-gray-600 text-sm mt-2"
//                   >
//                     <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                     </svg>
//                     Download PDF
//                   </a>

//                   <a
//                     href="#faqs"
//                     className="flex items-center text-gray-600 hover:text-gray-600 text-sm mt-2"
//                   >
//                     <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                     </svg>
//                     View FAQs
//                   </a>
//                 </div>

//                 <div className="mt-6 border-t border-gray-200 pt-4">
//                   <h3 className="text-sm font-medium text-gray-900 mb-2">Keywords</h3>
//                   <div className="flex flex-wrap gap-2">
//                     {article.keywords.map((keyword, index) => (
//                       <Link
//                         key={index}
//                         to={`/current-affairs/search?q=${encodeURIComponent(keyword)}`}
//                         className="inline-flex items-center px-2 py-1 rounded text-xs bg-gray-100 text-gray-800 hover:bg-gray-200"
//                       >
//                         {keyword}
//                       </Link>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               <div className="mt-6 bg-gradient-to-r from-purple-600 to-gray-600 rounded-lg shadow-md p-6 text-white">
//                 <h3 className="text-lg font-bold mb-2">Need Help Preparing?</h3>
//                 <p className="text-sm text-purple-100 mb-4">
//                   Join our comprehensive NPSC coaching program to master current affairs and other subjects.
//                 </p>
//                 <Link
//                   to="/courses"
//                   className="block w-full text-center py-2 px-4 rounded-md bg-white text-gray-700 font-medium hover:bg-gray-50 transition-colors"
//                 >
//                   Explore Courses
//                 </Link>
//               </div>
//             </div>
//           </div>

//           {/* Main Article Content */}
//           <div className="lg:col-span-9 order-1 lg:order-2">
//             <motion.div
//               className="bg-white rounded-lg shadow-md overflow-hidden"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               <div className="p-6 md:p-8">
//                 {/* Article Sections */}
//                 <div className="prose prose-gray max-w-none">
//                   {article.sections.map((section) => (
//                     <div
//                       key={section.id}
//                       id={section.id}
//                       ref={(el) => (sectionRefs.current[section.id] = el)}
//                       className="mb-10"
//                     >
//                       <h2 className="text-2xl font-bold text-gray-900 mb-4">{section.title}</h2>
//                       <div dangerouslySetInnerHTML={{ __html: section.content }} />
//                     </div>
//                   ))}
//                 </div>

//                 {/* FAQs Section */}
//                 <div id="faqs" className="mt-12 border-t border-gray-200 pt-8">
//                 <h2 className="text-2xl font-bold text-gray-900 mb-6">Frequently Asked Questions</h2>
//                   <div className="space-y-6">
//                     {article.faqs.map((faq, index) => (
//                       <div key={index} className="bg-gray-50 p-6 rounded-lg">
//                         <h3 className="text-lg font-medium text-gray-900 mb-2">{faq.question}</h3>
//                         <p className="text-gray-700">{faq.answer}</p>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 {/* Share and Bookmark Section */}
//                 <div className="mt-12 border-t border-gray-200 pt-6">
//                   <div className="flex flex-wrap items-center justify-between gap-4">
//                     <div className="flex items-center space-x-4">
//                       <span className="text-gray-700 font-medium">Share this article:</span>
//                       <div className="flex space-x-2">
//                         <button className="p-2 bg-blue-100 text-blue-600 rounded-full hover:bg-blue-200">
//                           <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
//                             <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
//                           </svg>
//                         </button>
//                         <button className="p-2 bg-blue-100 text-blue-800 rounded-full hover:bg-blue-200">
//                           <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
//                             <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
//                           </svg>
//                         </button>
//                         <button className="p-2 bg-blue-100 text-blue-600 rounded-full hover:bg-blue-200">
//                           <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
//                             <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
//                           </svg>
//                         </button>
//                         <button className="p-2 bg-green-100 text-green-600 rounded-full hover:bg-green-200">
//                           <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
//                             <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
//                           </svg>
//                         </button>
//                       </div>
//                     </div>

//                     <div className="flex items-center space-x-4">
//                       <button className="flex items-center text-gray-700 hover:text-gray-600">
//                         <svg className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
//                         </svg>
//                         <span>Save for later</span>
//                       </button>

//                       <div className="flex items-center space-x-2">
//                         <button className="p-2 bg-gray-100 text-gray-600 rounded-full hover:bg-gray-200">
//                           <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
//                           </svg>
//                         </button>

//                         <button className="p-2 bg-gray-100 text-gray-600 rounded-full hover:bg-gray-200">
//                           <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
//                           </svg>
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Author Profile */}
//                 <div className="mt-12 border-t border-gray-200 pt-6">
//                   <div className="bg-gray-50 p-6 rounded-lg">
//                     <div className="flex items-center">
//                       <div className="flex-shrink-0 mr-4">
//                         <div className="h-14 w-14 rounded-full bg-gray-100 flex items-center justify-center text-gray-700 text-2xl font-bold">
//                           {article.author.charAt(0)}
//                         </div>
//                       </div>
//                       <div>
//                         <h3 className="text-lg font-bold text-gray-900">{article.author}</h3>
//                         <p className="text-gray-600">{article.authorPosition}</p>
//                       </div>
//                     </div>
//                     <p className="mt-4 text-gray-700">
//                       Dr. Imtisunep Ao is a subject matter expert in Science & Technology with over 15 years of experience in NPSC coaching. He has authored numerous books on current affairs and scientific developments relevant to competitive examinations.
//                     </p>
//                     <div className="mt-4">
//                       <Link to="/faculty/profile/dr-imtisunep-ao" className="text-gray-600 hover:text-gray-800 font-medium">
//                         View full profile
//                       </Link>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Feedback Section */}
//                 <div className="mt-12 border-t border-gray-200 pt-6">
//                   <h3 className="text-lg font-bold text-gray-900 mb-4">Was this article helpful?</h3>
//                   <div className="flex space-x-4">
//                     <button className="flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50">
//                       <svg className="h-5 w-5 mr-2 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
//                       </svg>
//                       Yes, it was helpful
//                     </button>

//                     <button className="flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50">
//                       <svg className="h-5 w-5 mr-2 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v-2m0 4h.01m8.9-4h.01" />
//                       </svg>
//                       No, needs improvement
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </motion.div>
//           </div>
//         </div>
//       </div>

//       {/* Related Articles Section */}
//       <section className="bg-white py-12">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <h2 className="text-2xl font-bold text-gray-900 mb-8">Related Current Affairs</h2>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//             {article.related.map((relatedArticle) => (
//               <Link
//                 key={relatedArticle.id}
//                 to={`/current-affairs/${relatedArticle.id}`}
//                 className="block group"
//               >
//                 <div className="bg-white rounded-lg shadow-md overflow-hidden h-full transition-shadow hover:shadow-lg">
//                   <div className="h-48 overflow-hidden">
//                     <img
//                       src={relatedArticle.image}
//                       alt={relatedArticle.title}
//                       className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
//                     />
//                   </div>
//                   <div className="p-5">
//                     <div className="flex items-center text-xs text-gray-500 mb-2">
//                       <span className="bg-gray-100 text-gray-800 rounded-full px-2 py-1">
//                         {relatedArticle.category}
//                       </span>
//                       <span className="mx-2">•</span>
//                       <span>{relatedArticle.date}</span>
//                     </div>
//                     <h3 className="text-lg font-semibold text-gray-900 group-hover:text-gray-600 transition-colors">
//                       {relatedArticle.title}
//                     </h3>
//                     <div className="mt-4 flex justify-between items-center">
//                       <span className="text-sm text-gray-600 font-medium">Read more</span>
//                       <svg className="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
//                       </svg>
//                     </div>
//                   </div>
//                 </div>
//               </Link>
//             ))}
//           </div>

//           <div className="mt-10 text-center">
//             <Link
//               to="/current-affairs"
//               className="inline-flex items-center px-6 py-3 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
//             >
//               View All Current Affairs
//               <svg className="ml-2 -mr-1 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
//               </svg>
//             </Link>
//           </div>
//         </div>
//       </section>

//       {/* Newsletter Section */}
//       <section className="bg-gradient-to-r from-gray-600 to-blue-700 py-12">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="lg:flex lg:items-center lg:justify-between">
//             <div className="lg:w-0 lg:flex-1">
//               <h2 className="text-2xl font-extrabold tracking-tight text-white sm:text-3xl">
//                 Stay updated with Current Affairs
//               </h2>
//               <p className="mt-3 max-w-3xl text-lg text-gray-100">
//                 Get weekly updates on important current affairs topics directly in your inbox. Perfect for NPSC preparation.
//               </p>
//             </div>
//             <div className="mt-8 lg:mt-0 lg:ml-8">
//               <form className="sm:flex">
//                 <label htmlFor="email-address" className="sr-only">Email address</label>
//                 <input
//                   id="email-address"
//                   name="email"
//                   type="email"
//                   autoComplete="email"
//                   required
//                   className="w-full px-5 py-3 border-white focus:ring-white focus:border-white rounded-md placeholder-gray-500"
//                   placeholder="Enter your email"
//                 />
//                 <div className="mt-3 rounded-md shadow sm:mt-0 sm:ml-3 sm:flex-shrink-0">
//                   <button
//                     type="submit"
//                     className="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none"
//                   >
//                     Subscribe
//                   </button>
//                 </div>
//               </form>
//               <p className="mt-3 text-sm text-gray-100">
//                 We care about your data. Read our{' '}
//                 <Link to="/privacy-policy" className="font-medium underline text-white">
//                   Privacy Policy
//                 </Link>.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Scroll to Top Button */}
//       {showScrollToTop && (
//         <button
//           onClick={scrollToTop}
//           className="fixed bottom-8 right-8 p-2 rounded-full bg-gray-600 text-white shadow-lg hover:bg-gray-700 focus:outline-none transition-colors z-50"
//           aria-label="Scroll to top"
//         >
//           <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 11l7-7 7 7M5 19l7-7 7 7" />
//           </svg>
//         </button>
//       )}
//     </div>
//   );
// };

// export default CurrentAffairsDetailPage;

import React, { useEffect, useState, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useCurrentAffairs } from "../context/CurrentAffairsContext";
import Spinner from "../components/common/Spinner";
import ErrorAlert from "../components/common/ErrorAlert";
import { formatDate } from "../utils/dateUtils";

const CurrentAffairsDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    currentAffair,
    loading,
    error,
    fetchCurrentAffairById,
    clearCurrentAffair,
  } = useCurrentAffairs();

  const [activeSection, setActiveSection] = useState(null);
  const [showScrollToTop, setShowScrollToTop] = useState(false);

  const sectionRefs = useRef({});

  useEffect(() => {
    window.scrollTo(0, 0);

    // Fetch the current affairs article
    fetchCurrentAffairById(id);

    // Cleanup on unmount
    return () => clearCurrentAffair();
  }, [id, fetchCurrentAffairById, clearCurrentAffair]);

  useEffect(() => {
    const handleScroll = () => {
      // Show scroll to top button when user scrolls down
      setShowScrollToTop(window.scrollY > 300);

      // Update active section based on scroll position
      if (sectionRefs.current && currentAffair) {
        const sections = Object.keys(sectionRefs.current);
        for (const section of sections) {
          const element = sectionRefs.current[section];
          if (element) {
            const rect = element.getBoundingClientRect();
            if (rect.top <= 100 && rect.bottom >= 100) {
              setActiveSection(section);
              break;
            }
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [currentAffair]);

  const scrollToSection = (sectionId) => {
    const element = sectionRefs.current[sectionId];
    if (element) {
      const offset = 80; // Account for fixed header
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (loading) {
    return (
      <div className="pt-20 flex justify-center items-center min-h-screen bg-gray-50">
        <Spinner message="Loading article..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="pt-20 flex justify-center items-center min-h-screen bg-gray-50">
        <ErrorAlert message={error} />
      </div>
    );
  }

  if (!currentAffair) {
    return (
      <div className="pt-20 flex justify-center items-center min-h-screen bg-gray-50">
        <div className="text-center max-w-lg mx-auto px-4">
          <svg
            className="h-16 w-16 text-gray-400 mx-auto"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <h2 className="mt-4 text-xl font-bold text-gray-700">
            Article Not Found
          </h2>
          <p className="mt-2 text-gray-500">
            The article you're looking for doesn't exist or has been removed.
          </p>
          <Link
            to="/current-affairs"
            className="mt-6 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-gray-600 hover:bg-gray-700"
          >
            Back to Current Affairs
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-20 bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-gray-900 text-white">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900 to-blue-900 opacity-90"></div>
          {currentAffair.image && (
            <img
              src={currentAffair.image}
              alt={currentAffair.title}
              className="absolute inset-0 w-full h-full object-cover mix-blend-overlay opacity-40"
            />
          )}
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
          <div className="max-w-3xl">
            <div className="mb-4 flex items-center space-x-2">
              <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-gray-100 text-gray-800">
                {currentAffair.category.charAt(0).toUpperCase() +
                  currentAffair.category.slice(1)}
              </span>
              <span className="text-gray-200 text-sm">
                {formatDate(currentAffair.date)}
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight mb-6">
              {currentAffair.title}
            </h1>

            <p className="text-xl text-gray-100 mb-8">
              {currentAffair.summary}
            </p>

            <div className="flex flex-wrap items-center gap-3 md:gap-6 text-sm text-gray-200">
              <div className="flex items-center">
                <div className="flex-shrink-0 mr-2">
                  <div className="h-10 w-10 rounded-full bg-gray-700 flex items-center justify-center text-xl font-bold">
                    {currentAffair.author?.charAt(0) || "A"}
                  </div>
                </div>
                <div>
                  <div className="font-medium text-white">
                    {currentAffair.author}
                  </div>
                  <div className="text-xs">{currentAffair.authorPosition}</div>
                </div>
              </div>

              <div className="flex items-center">
                <svg
                  className="h-5 w-5 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span>{currentAffair.readTime || "10 min read"}</span>
              </div>

              <div className="flex items-center">
                <svg
                  className="h-5 w-5 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
                  />
                </svg>
                <span>Save for later</span>
              </div>

              <div className="flex items-center">
                <svg
                  className="h-5 w-5 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                  />
                </svg>
                <span>Share</span>
              </div>
            </div>

            <div className="mt-8 flex flex-wrap gap-2">
              {currentAffair.relevance?.map((item, index) => (
                <span
                  key={index}
                  className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-gray-800 text-gray-100"
                >
                  {item}
                </span>
              ))}

              {currentAffair.prelimsRelevance && (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-green-800 text-green-100">
                  Prelims Relevant
                </span>
              )}

              {currentAffair.mainsRelevance && (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-blue-800 text-blue-100">
                  Mains Relevant
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Main Content with Sidebar */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* Table of Contents Sidebar - Fixed on Desktop */}
          <div className="lg:col-span-3 order-2 lg:order-1">
            <div className="lg:sticky lg:top-24">
              <div className="bg-white rounded-lg shadow-md p-6">
                <h2 className="text-lg font-bold text-gray-900 mb-4">
                  In This Article
                </h2>
                <nav className="space-y-2">
                  {currentAffair.sections?.map((section) => (
                    <button
                      key={section.id}
                      onClick={() => scrollToSection(section.id)}
                      className={`block w-full text-left px-3 py-2 rounded text-sm ${
                        activeSection === section.id
                          ? "bg-gray-50 text-gray-700 font-medium"
                          : "text-gray-600 hover:bg-gray-50"
                      }`}
                    >
                      {section.title}
                    </button>
                  ))}
                </nav>

                <div className="mt-6 border-t border-gray-200 pt-4">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      window.print();
                    }}
                    className="flex items-center text-gray-600 hover:text-gray-600 text-sm"
                  >
                    <svg
                      className="h-4 w-4 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
                      />
                    </svg>
                    Print Article
                  </a>

                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      // PDF download logic would go here
                      alert("Downloading PDF...");
                    }}
                    className="flex items-center text-gray-600 hover:text-gray-600 text-sm mt-2"
                  >
                    <svg
                      className="h-4 w-4 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                    Download PDF
                  </a>

                  <a
                    href="#faqs"
                    className="flex items-center text-gray-600 hover:text-gray-600 text-sm mt-2"
                  >
                    <svg
                      className="h-4 w-4 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    View FAQs
                  </a>
                </div>

                <div className="mt-6 border-t border-gray-200 pt-4">
                  <h3 className="text-sm font-medium text-gray-900 mb-2">
                    Keywords
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {currentAffair.keywords?.map((keyword, index) => (
                      <Link
                        key={index}
                        to={`/current-affairs/search?q=${encodeURIComponent(
                          keyword
                        )}`}
                        className="inline-flex items-center px-2 py-1 rounded text-xs bg-gray-100 text-gray-800 hover:bg-gray-200"
                      >
                        {keyword}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>

              <div className="mt-6 bg-gradient-to-r from-purple-600 to-gray-600 rounded-lg shadow-md p-6 text-white">
                <h3 className="text-lg font-bold mb-2">Need Help Preparing?</h3>
                <p className="text-sm text-purple-100 mb-4">
                  Join our comprehensive NPSC coaching program to master current
                  affairs and other subjects.
                </p>
                <Link
                  to="/courses"
                  className="block w-full text-center py-2 px-4 rounded-md bg-white text-gray-700 font-medium hover:bg-gray-50 transition-colors"
                >
                  Explore Courses
                </Link>
              </div>
            </div>
          </div>

          {/* Main Article Content */}
          <div className="lg:col-span-9 order-1 lg:order-2">
            <motion.div
              className="bg-white rounded-lg shadow-md overflow-hidden"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div className="p-6 md:p-8">
                {/* Article Sections */}
                <div className="prose prose-gray max-w-none">
                  {currentAffair.sections?.map((section) => (
                    <div
                      key={section.id}
                      id={section.id}
                      ref={(el) => (sectionRefs.current[section.id] = el)}
                      className="mb-10"
                    >
                      <h2 className="text-2xl font-bold text-gray-900 mb-4">
                        {section.title}
                      </h2>
                      <div
                        dangerouslySetInnerHTML={{ __html: section.content }}
                      />
                    </div>
                  ))}
                </div>

                {/* FAQs Section */}
                {currentAffair.faqs && currentAffair.faqs.length > 0 && (
                  <div
                    id="faqs"
                    className="mt-12 border-t border-gray-200 pt-8"
                  >
                    <h2 className="text-2xl font-bold text-gray-900 mb-6">
                      Frequently Asked Questions
                    </h2>
                    <div className="space-y-6">
                      {currentAffair.faqs.map((faq, index) => (
                        <div key={index} className="bg-gray-50 p-6 rounded-lg">
                          <h3 className="text-lg font-medium text-gray-900 mb-2">
                            {faq.question}
                          </h3>
                          <p className="text-gray-700">{faq.answer}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Share and Bookmark Section */}
                <div className="mt-12 border-t border-gray-200 pt-6">
                  <div className="flex flex-wrap items-center justify-between gap-4">
                    <div className="flex items-center space-x-4">
                      <span className="text-gray-700 font-medium">
                        Share this article:
                      </span>
                      <div className="flex space-x-2">
                        <button className="p-2 bg-blue-100 text-blue-600 rounded-full hover:bg-blue-200">
                          <svg
                            className="h-5 w-5"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                          </svg>
                        </button>
                        <button className="p-2 bg-blue-100 text-blue-800 rounded-full hover:bg-blue-200">
                          <svg
                            className="h-5 w-5"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                          </svg>
                        </button>
                        <button className="p-2 bg-blue-100 text-blue-600 rounded-full hover:bg-blue-200">
                          <svg
                            className="h-5 w-5"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                          </svg>
                        </button>
                        <button className="p-2 bg-green-100 text-green-600 rounded-full hover:bg-green-200">
                          <svg
                            className="h-5 w-5"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
                          </svg>
                        </button>
                      </div>
                    </div>

                    <div className="flex items-center space-x-4">
                      <button className="flex items-center text-gray-700 hover:text-gray-600">
                        <svg
                          className="h-5 w-5 mr-1"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
                          />
                        </svg>
                        <span>Save for later</span>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Author Profile */}
                <div className="mt-12 border-t border-gray-200 pt-6">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="flex items-center">
                      <div className="flex-shrink-0 mr-4">
                        <div className="h-14 w-14 rounded-full bg-gray-100 flex items-center justify-center text-gray-700 text-2xl font-bold">
                          {currentAffair.author?.charAt(0) || "A"}
                        </div>
                      </div>
                      <div>
                        <h3 className="text-lg font-bold text-gray-900">
                          {currentAffair.author}
                        </h3>
                        <p className="text-gray-600">
                          {currentAffair.authorPosition}
                        </p>
                      </div>
                    </div>
                    <p className="mt-4 text-gray-700">
                      {currentAffair.author} is a subject matter expert with
                      extensive experience in NPSC coaching. They have authored
                      numerous articles on current affairs and developments
                      relevant to competitive examinations.
                    </p>
                    <div className="mt-4">
                      <Link
                        to={`/faculty/profile/${currentAffair.author
                          ?.toLowerCase()
                          .replace(/\s+/g, "-")}`}
                        className="text-gray-600 hover:text-gray-800 font-medium"
                      >
                        View full profile
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Feedback Section */}
                <div className="mt-12 border-t border-gray-200 pt-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-4">
                    Was this article helpful?
                  </h3>
                  <div className="flex space-x-4">
                    <button className="flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50">
                      <svg
                        className="h-5 w-5 mr-2 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
                        />
                      </svg>
                      Yes, it was helpful
                    </button>

                    <button className="flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50">
                      <svg
                        className="h-5 w-5 mr-2 text-red-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v-2m0 4h.01m8.9-4h.01"
                        />
                      </svg>
                      No, needs improvement
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Related Articles Section */}
      {currentAffair.related && currentAffair.related.length > 0 && (
        <section className="bg-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-8">
              Related Current Affairs
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {currentAffair.related.map((relatedArticle) => (
                <Link
                  key={relatedArticle._id}
                  to={`/current-affairs/${relatedArticle._id}`}
                  className="block group"
                >
                  <div className="bg-white rounded-lg shadow-md overflow-hidden h-full transition-shadow hover:shadow-lg">
                    <div className="h-48 overflow-hidden">
                      <img
                        src={relatedArticle.image}
                        alt={relatedArticle.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                    <div className="p-5">
                      <div className="flex items-center text-xs text-gray-500 mb-2">
                        <span className="bg-gray-100 text-gray-800 rounded-full px-2 py-1">
                          {relatedArticle.category.charAt(0).toUpperCase() +
                            relatedArticle.category.slice(1)}
                        </span>
                        <span className="mx-2">•</span>
                        <span>{formatDate(relatedArticle.date)}</span>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900 group-hover:text-gray-600 transition-colors">
                        {relatedArticle.title}
                      </h3>
                      <div className="mt-4 flex justify-between items-center">
                        <span className="text-sm text-gray-600 font-medium">
                          Read more
                        </span>
                        <svg
                          className="h-5 w-5 text-gray-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            <div className="mt-10 text-center">
              <Link
                to="/current-affairs"
                className="inline-flex items-center px-6 py-3 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
              >
                View All Current Affairs
                <svg
                  className="ml-2 -mr-1 h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </section>
      )}

      {/* Newsletter Section */}
      <section className="bg-gradient-to-r from-gray-600 to-blue-700 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:flex lg:items-center lg:justify-between">
            <div className="lg:w-0 lg:flex-1">
              <h2 className="text-2xl font-extrabold tracking-tight text-white sm:text-3xl">
                Stay updated with Current Affairs
              </h2>
              <p className="mt-3 max-w-3xl text-lg text-gray-100">
                Get weekly updates on important current affairs topics directly
                in your inbox. Perfect for NPSC preparation.
              </p>
            </div>
            <div className="mt-8 lg:mt-0 lg:ml-8">
              <form className="sm:flex">
                <label htmlFor="email-address" className="sr-only">
                  Email address
                </label>
                <input
                  id="email-address"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="w-full px-5 py-3 border-white focus:ring-white focus:border-white rounded-md placeholder-gray-500"
                  placeholder="Enter your email"
                />
                <div className="mt-3 rounded-md shadow sm:mt-0 sm:ml-3 sm:flex-shrink-0">
                  <button
                    type="submit"
                    className="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none"
                  >
                    Subscribe
                  </button>
                </div>
              </form>
              <p className="mt-3 text-sm text-gray-100">
                We care about your data. Read our{" "}
                <Link
                  to="/privacy-policy"
                  className="font-medium underline text-white"
                >
                  Privacy Policy
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Scroll to Top Button */}
      {showScrollToTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 p-2 rounded-full bg-gray-600 text-white shadow-lg hover:bg-gray-700 focus:outline-none transition-colors z-50"
          aria-label="Scroll to top"
        >
          <svg
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 11l7-7 7 7M5 19l7-7 7 7"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default CurrentAffairsDetailPage;
